// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hkownwweihaqtwnjbdzy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhrb3dud3dlaWhhcXR3bmpiZHp5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMwMDkyMzAsImV4cCI6MjA2ODU4NTIzMH0.w_px24e-ChMw4cgvFfDutU7E4PUpNvN__KA36xY5LFI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});